import React from "react";
import Image from "next/image";

function preprocessUrl(url) {
  if (!url) return "";
  url = url.trim();
  if (!url.includes("?") && url.includes("&")) {
    const firstAmpIndex = url.indexOf("&");
    url = url.slice(0, firstAmpIndex) + "?" + url.slice(firstAmpIndex + 1);
  }
  return url;
}

const ImageComponent = (props) => {
  const {
    src: rawSrc,
    alt,
    priority,
    quality,
    placeholder,
    blurDataURL,
    loader,
    unoptimized,
    fill,
    ...rest
  } = props;
  const src = preprocessUrl(rawSrc);
  const isWebp = /\.webp(\?|#|$)/i.test(src);

  return (
    <>
      {isWebp ? (
        <img
          {...rest}
          src={encodeURI(src)}
          alt={alt || "image"}
          decoding="async"
        />
      ) : (
        <Image
          {...props}
          src={encodeURI(src)}
          alt={alt || "image"}
          priority
        />
      )}
    </>
  );
};

export default ImageComponent;
